import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "wthree animate__animated animate__backInLeft nimate__backInDown row",
  style: {"width":"100%"}
}
const _hoisted_3 = { class: "row col-md-12 agileits-w3layouts animate__animated nimate__backInDown" }

import * as  http from '@/request/http'
    import { ref, onMounted } from 'vue'
    import { nextTick } from 'vue';
    import { reactive} from 'vue';

    interface PortalProjectMedicines {
      projectName: string
      therapyArea: string
      studyPhase: string
      indication: string
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectMedicine',
  setup(__props) {

    const tableRowClassName = ({
      row,
      rowIndex,
    }: {
      row: PortalProjectMedicines
      rowIndex: number
    }) => {
      if (rowIndex === 1) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      }
      return ''
    }
    onMounted(async () => {
      try {
 
        handlePageChanged( {newPage:1})
      } catch (error) {
        console.error('Error loading data:', error);
      }
    });
    const  handlePageChanged=({
      newPage
     }: {
      newPage: 1
    })=> {
       let  param = {
          newTitle: '',
          currentPage: newPage
       }
        http.projectMedicines.projectMedicineslist(param).then(res=>{
           console.log(tableData)
           res.data.rows.forEach(item=>{
            tableData.push(item)
           })
        nextTick(); // 等待 DOM 更新完成
        })
    }
     const  tableData: PortalProjectMedicines[] = reactive([
    ])

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "agileits-title w3title1" }, "重点项目", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w3ls-title" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "clearfix" }, null, -1)),
          _createVNode(_component_el_table, {
            stripe: "true",
            data: tableData,
            style: {"width":"100%"},
            "row-class-name": tableRowClassName
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "projectName",
                label: "主要候选药品",
                width: "260"
              }),
              _createVNode(_component_el_table_column, {
                prop: "therapyArea",
                label: "治疗领域",
                width: "260"
              }),
              _createVNode(_component_el_table_column, {
                prop: "studyPhase",
                label: "研究阶段",
                width: "260"
              }),
              _createVNode(_component_el_table_column, {
                prop: "indication",
                label: "适应症",
                width: "260"
              }),
              _createVNode(_component_el_table_column, {
                prop: "projectType",
                label: "项目类型",
                width: "260"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "clearfix" }, null, -1))
      ])
    ])
  ]))
}
}

})